import React from 'react';
import { Sparkles, Check } from 'lucide-react';

export default function ServiceStep({ 
  services, 
  selectedServiceType, 
  setSelectedServiceType, 
  selectedVehicleSize, 
  setSelectedVehicleSize,
  WHATS_INCLUDED,
  BASIC_CLEANING_INCLUDED
}) {
  if (!services) return null;

  return (
    <div className="animate-fade-in" data-testid="cleaning-step-1">
      <h2 className="text-2xl font-bold text-slate-900 font-['Outfit'] mb-2">Select Your Service</h2>
      <p className="text-slate-500 mb-6">Choose the cleaning type and your vehicle size</p>

      {/* Service Type */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {Object.entries(services).map(([key, svc]) => (
          <div
            key={key}
            onClick={() => { setSelectedServiceType(key); setSelectedVehicleSize(''); }}
            className={`border-2 rounded-xl p-5 cursor-pointer transition-all ${
              selectedServiceType === key ? 'border-emerald-500 bg-emerald-50' : 'border-slate-200 hover:border-emerald-300'
            }`}
            data-testid={`cleaning-type-${key}`}
          >
            <h3 className="font-bold text-lg text-slate-900">{svc.name}</h3>
            <p className="text-sm text-slate-500 mt-1">
              {key === 'residential' ? 'Pesach cleaning - Chametz free guaranteed' : 'Complete interior & exterior detail'}
            </p>
            <p className="text-emerald-600 font-semibold mt-2">
              From ${Math.min(...Object.values(svc.sizes).map(s => s.price))}
            </p>
          </div>
        ))}
      </div>

      {/* Vehicle Size */}
      {selectedServiceType && (
        <>
          <h3 className="font-semibold text-slate-900 mb-3">Select Vehicle Size</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {Object.entries(services[selectedServiceType].sizes).map(([sizeKey, sizeData]) => {
              const vehicleIcons = {
                'sedan': '/vehicle-sedan.png',
                '2_row_suv': '/vehicle-2row-suv.png',
                '3_row_suv': '/vehicle-3row-suv.png',
                'minivan': '/vehicle-minivan.png'
              };
              return (
                <div
                  key={sizeKey}
                  onClick={() => setSelectedVehicleSize(sizeKey)}
                  className={`border-2 rounded-xl p-4 cursor-pointer transition-all text-center ${
                    selectedVehicleSize === sizeKey ? 'border-emerald-500 bg-emerald-50' : 'border-slate-200 hover:border-emerald-300'
                  }`}
                  data-testid={`cleaning-size-${sizeKey}`}
                >
                  <img 
                    src={vehicleIcons[sizeKey]} 
                    alt={sizeData.label} 
                    className="w-16 h-16 mx-auto mb-2 object-contain"
                  />
                  <p className="font-semibold text-slate-900">{sizeData.label}</p>
                  <p className="text-emerald-600 font-bold text-xl mt-1">${sizeData.price}</p>
                </div>
              );
            })}
          </div>
        </>
      )}

      {/* What's Included */}
      {selectedServiceType === 'full_detailing' && (
        <div className="mt-6 bg-slate-50 rounded-xl p-5">
          <h3 className="font-semibold text-slate-900 mb-3">What's Included</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h4 className="text-sm font-semibold text-emerald-600 mb-2">Exterior</h4>
              {WHATS_INCLUDED.exterior.map(item => (
                <div key={item} className="flex items-center gap-2 text-sm text-slate-600 py-0.5">
                  <Check className="w-3.5 h-3.5 text-emerald-500 flex-shrink-0" />
                  {item}
                </div>
              ))}
            </div>
            <div>
              <h4 className="text-sm font-semibold text-emerald-600 mb-2">Interior</h4>
              {WHATS_INCLUDED.interior.map(item => (
                <div key={item} className="flex items-center gap-2 text-sm text-slate-600 py-0.5">
                  <Check className="w-3.5 h-3.5 text-emerald-500 flex-shrink-0" />
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {selectedServiceType === 'residential' && (
        <div className="mt-6 bg-emerald-50 rounded-xl p-5">
          <h3 className="font-semibold text-slate-900 mb-3">What's Included in Platinum Package</h3>
          <div>
            <h4 className="text-sm font-semibold text-emerald-600 mb-2">Interior</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4">
              {BASIC_CLEANING_INCLUDED.interior.map(item => (
                <div key={item} className="flex items-center gap-2 text-sm text-slate-600 py-0.5">
                  <Check className="w-3.5 h-3.5 text-emerald-500 flex-shrink-0" />
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
